import PropTypes from 'prop-types';
import React from 'react';
import * as rmd from 'material-ui';
import _ from 'lodash';
import auth from '../auth';
import { red500 } from 'material-ui/styles/colors';
import ErrorIcon from 'material-ui/svg-icons/alert/error';
import { Link } from 'react-router';
import config from 'cfg';

const notFoundIconStyle = {
    width: 30,
    height: 30,
    marginRight: 15,
    marginBottom: -10,
};

const widgetImageStyle = {
    maxWidth: '400px',
    margin: '0px auto',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat',
};

class WidgetPick extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            spec: {},
            filter: 'all',
        };
        this.loadData();
    }

    static contextTypes = {
        user: PropTypes.object.isRequired,
    };

    colors = ['#F4013C', '#F46E02', '#04A9F4'];

    filters = [
        { type: 'all', label: 'All' },
        { type: 'tournamentId', label: 'Only for league' },
        { type: 'teamId', label: 'Only for club' },
        { type: 'playerId', label: 'Only for player' },
        { type: 'eventId', label: 'Only for match' },
        { type: 'social', label: 'Social' },
    ];

    loadData = () => {
        const { user } = this.context;
        if (user && user.client) {
            // widgets/standalone/FixturesList/spec
            fetch(`${config.dash.api.host}/api/widgets/spec?access_token=${auth.getAccessToken()}`)
                .then(response => response.json())
                .then(spec => {
                    this.setState({ spec, isLoading: false });
                })
                .catch(err => {
                    this.setState({ specError: err, isLoading: false });
                });
        } else {
            console.warn('No user data in context', user);
        }
    };

    handleFilterChange = (event, index, filter) => this.setState({ filter });

    getNotFoundSpec = () => {
        const { user } = this.context;
        const client = _.get(user, 'client', '');
        return (
            <div>
                <ErrorIcon color={red500} style={notFoundIconStyle} />
                Widget specification not found for client {client}
            </div>
        );
    };

    /**
     * @deprecated
     */
    getGroups = () => {
        const { spec } = this.state;
        return this.filters.map(f => {
            return {
                key: f.key,
                widgets: _.filter(spec.widgets, widget => {
                    return _.find(widget.spec.propTypes, p => {
                        return p.key === f.key;
                    });
                }),
            };
        });
    };

    renderFilterDropdown = () => {
        const { filter } = this.state;
        const options = this.filters.map(filter => (
            <rmd.MenuItem value={filter.type} key={filter.type} primaryText={filter.label} />
        ));

        return (
            <rmd.DropDownMenu value={filter} onChange={this.handleFilterChange}>
                {options}
            </rmd.DropDownMenu>
        );
    };

    getFilteredWidgets = () => {
        const {
            spec: { widgets },
            filter,
        } = this.state;

        if (filter === 'social') {
            return _.filter(widgets, s => !_.isEmpty(s.spec) && s.spec.social);
        }
        if (filter === 'all') {
            return _.filter(widgets, s => !_.isEmpty(s.spec) && !s.spec.social);
        }

        return _.filter(widgets, s => {
            return !s.spec.social && _.find(s.spec.propTypes, p => p.key === filter);
        });
    };

    renderWidgets = () => {
        const { spec, filter } = this.state;
        if (!Array.isArray(_.get(spec, 'widgets'))) {
            return null;
        }
        const widgets = this.getFilteredWidgets();
        return widgets.map(this.renderSingleWidget);
    };

    renderSingleWidget = widget => {
        const { user } = this.context;
        const snapshotUrl = `${config.widgets.url}/widget/${user.client}/${user.username}/default/${
            widget.id
        }/demo-image?a=test`;

        return (
            <div key={widget.id} className="col-xs-12 col-sm-6 col-md-6">
                <rmd.Card className="widget-template">
                    <div style={{ height: '1px' }} />
                    <div className="widget-preview-box" style={{ textAlign: 'center', background: '#444' }}>
                        <img
                            src={snapshotUrl}
                            style={{
                                width: '90%',
                                maxHeight: 300,
                                minHeight: 300,
                                objectFit: 'contain',
                            }}
                        />
                    </div>
                    <rmd.CardTitle titleStyle={{ fontSize: '18px' }} title={widget.name} />
                    <rmd.CardActions className="actions">
                        <Link to={`/widgets/${widget.id}/show-case/${widget.name}`}>
                            <rmd.FlatButton label="Demo" />
                        </Link>
                        <Link to={`/widgets/${widget.id}/customizer`}>
                            <rmd.FlatButton className="create" label="Create" primary />
                        </Link>
                    </rmd.CardActions>
                </rmd.Card>
            </div>
        );
    };

    render() {
        var user = this.context.user;
        var { spec, specError, filter } = this.state;

        if (!spec) {
            return this.getNotFoundSpec();
        }

        return (
            <div className="pick-widget">
                <div style={{ padding: '16px 0' }}>{this.renderFilterDropdown()}</div>
                <div className="row">{this.renderWidgets()}</div>
            </div>
        );
    }
}

export default WidgetPick;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/WidgetPick.js
 **/